(function () {
  'use strict';

  var endpoint = 'https://portal.binderpos.com/external/shopify/products/forStore';
  var binderPageStep = 18;
  var configuredPageSize = parseInt(window.vmaxBinderPosPageSize, 10);
  var allowedPageSizes = [18, 24, 36, 72, 250];
  var pageSize = allowedPageSizes.indexOf(configuredPageSize) > -1 ? configuredPageSize : 18;
  var originalFetch = window.fetch;

  window.vmaxBinderPosPageSize = pageSize;
  window.vmaxBinderPosResultMeta = null;

  function getUrl(input) {
    return typeof input === 'string' ? input : input && input.url;
  }

  function getTotal(data) {
    var candidates = [
      data && data.count,
      data && data.total,
      data && data.totalCount,
      data && data.productsCount,
      data && data.totalProducts,
      data && data.pagination && data.pagination.total
    ];

    for (var i = 0; i < candidates.length; i += 1) {
      var total = parseInt(candidates[i], 10);
      if (!isNaN(total) && total >= 0) return total;
    }

    return null;
  }

  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = getUrl(input);

      if (url === endpoint && init && init.body) {
        try {
          var requestData = JSON.parse(init.body);
          var virtualOffset = parseInt(requestData.offset, 10) || 0;
          var pageIndex = Math.max(0, Math.floor(virtualOffset / binderPageStep));
          var actualOffset = pageIndex * pageSize;
          requestData.limit = pageSize;
          requestData.offset = actualOffset;

          var adjustedInit = Object.assign({}, init, { body: JSON.stringify(requestData) });

          return originalFetch.call(this, input, adjustedInit).then(function (response) {
            if (!response || typeof response.clone !== 'function') return response;

            return response.clone().json().then(function (data) {
              var products = Array.isArray(data.products) ? data.products : [];
              var total = getTotal(data);

              window.vmaxBinderPosResultMeta = {
                actualOffset: actualOffset,
                pageIndex: pageIndex,
                pageSize: pageSize,
                productCount: products.length,
                total: total
              };

              data.offset = pageIndex * binderPageStep;
              var responseHeaders = new Headers(response.headers);
              responseHeaders.delete('content-encoding');
              responseHeaders.delete('content-length');

              return new Response(JSON.stringify(data), {
                status: response.status,
                statusText: response.statusText,
                headers: responseHeaders
              });
            }).catch(function () {
              return response;
            });
          });
        } catch (error) {
          return originalFetch.call(this, input, init);
        }
      }

      return originalFetch.call(this, input, init);
    };
  }

  function disabledButton(direction, label) {
    var icon = direction === 'previous' ? '&#xE314;' : '&#xE315;';
    return '<div class="btn btn--secondary btn--narrow btn--disabled" aria-disabled="true">' +
      '<i class="material-icons">' + icon + '</i>' +
      '<span class="icon__fallback-text">' + label + '</span>' +
      '</div>';
  }

  function translateNavigation(container) {
    if (!container) return;

    container.querySelectorAll('.icon__fallback-text').forEach(function (label) {
      var text = label.textContent.trim().toLowerCase();
      if (text === 'prev' || text === 'previous') label.textContent = 'Précédent';
      if (text === 'next') label.textContent = 'Suivant';
    });
  }

  function syncSecondaryPagination(primary, secondary) {
    ['.pag_previous', '.pag_next'].forEach(function (selector) {
      var primaryControl = primary.querySelector(selector);
      var secondaryControl = secondary.querySelector(selector);
      if (!primaryControl || !secondaryControl) return;

      if (secondaryControl.innerHTML !== primaryControl.innerHTML) {
        secondaryControl.innerHTML = primaryControl.innerHTML;
      }

      secondaryControl.onclick = function (event) {
        event.preventDefault();
        if (primaryControl.onclick) primaryControl.onclick(event);
      };
    });
  }

  function syncBinderPosResults() {
    var meta = window.vmaxBinderPosResultMeta;
    if (!meta) return;

    var first = meta.productCount > 0 ? meta.actualOffset + 1 : 0;
    var last = meta.actualOffset + meta.productCount;
    var total = meta.total;
    var countText = total === null
      ? 'Produits ' + first + ' à ' + last
      : 'Produits ' + first + ' à ' + last + ' sur un total de ' + total;

    document.querySelectorAll('.filters-toolbar__product-count, [data-vmax-binder-pagination] .pagination__text').forEach(function (element) {
      if (element.textContent.trim() !== countText) element.textContent = countText;
    });

    document.querySelectorAll('[data-vmax-all-option]').forEach(function (option) {
      var label = total !== null && total <= 250 ? 'Tout' : '250 (maximum Shopify)';
      if (option.textContent.trim() !== label) option.textContent = label;
    });

    var paginations = document.querySelectorAll('[data-vmax-binder-pagination]');
    if (!paginations.length) return;

    var primary = paginations[0];
    var previous = primary.querySelector('.pag_previous');
    var next = primary.querySelector('.pag_next');
    var atStart = meta.actualOffset === 0;
    var atEnd = total !== null
      ? last >= total
      : meta.productCount < meta.pageSize;

    if (atStart && previous) {
      previous.onclick = null;
      previous.innerHTML = disabledButton('previous', 'Précédent');
    }

    if (atEnd && next) {
      next.onclick = null;
      next.innerHTML = disabledButton('next', 'Suivant');
    }

    translateNavigation(primary);

    for (var i = 1; i < paginations.length; i += 1) {
      syncSecondaryPagination(primary, paginations[i]);
      translateNavigation(paginations[i]);
    }
  }

  function preserveSearchTermOnProductTypeLinks() {
    var sealedLink = document.querySelector('[data-vmax-sealed-products-link]');
    var allProductsLink = document.querySelector('[data-vmax-all-products-link]');
    if (!sealedLink && !allProductsLink) return;

    var term = new URL(window.location.href).searchParams.get('q') || '';

    if (sealedLink) {
      var sealedTarget = new URL('/search', window.location.origin);
      sealedTarget.searchParams.set('q', term);
      sealedTarget.searchParams.set('type', 'product');
      sealedTarget.searchParams.set('options[prefix]', 'last');
      sealedTarget.searchParams.set('filter.p.product_type', 'Pokemon Sealed');
      sealedLink.href = sealedTarget.pathname + sealedTarget.search;
    }

    if (allProductsLink) {
      var allProductsTarget = new URL('/search', window.location.origin);
      allProductsTarget.searchParams.set('q', term);
      allProductsTarget.searchParams.set('type', 'product');
      allProductsTarget.searchParams.set('options[prefix]', 'last');
      allProductsLink.href = allProductsTarget.pathname + allProductsTarget.search;
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    preserveSearchTermOnProductTypeLinks();

    var syncQueued = false;
    var observer = new MutationObserver(function () {
      if (syncQueued) return;
      syncQueued = true;
      window.requestAnimationFrame(function () {
        syncQueued = false;
        syncBinderPosResults();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    syncBinderPosResults();
  });
})();
